/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-12-06 09:53:45
 * @LastEditTime: 2020-03-26 10:48:02
 * @LastEditors: 李方强
 */
/** 
 
- 禁用过滤器(filter），采用函数包装的形式代替，如：{{ filterCompany(data) }}
- 禁用 directive （涉及dom操作），推荐改用直接传递 props 形式，包装成一个新的组件
- 禁用 mixins，因为它会带来隐式的依赖传递，随着后期维护成本攀升，会导致名称冲突、业务逻辑冲突等等潜在的风险，尽可能的将代码包装成一个class模块或者vue组件，以便让代码内聚更高，可维护可扩展性更高

 */

import Vue from 'vue'
import * as GlobalUI from '@ui/manage'
import * as filters from '@core/filters' // 全局vue filter
import DOMPurify from 'dompurify'
import * as yunjiComponents from 'yunji-components'
import App from '@/App.vue'
import router from '@/routers'
import '@/registerServiceWorker'
import '@core/polyfill' // 原型方法
import * as ElementUI from '@/element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@ui/manage/styles/index.less'
import store from '@/store'
import { YjErrorReport } from '@yunji/report'
// 防止重复点击指令
import preventReClick from './utils/config/preventReclick'
import bus from './utils/bus'
 
/**
 * 原因：包黄说没有添加被动监听器来阻止'touchstart'事件，请考虑添加事件管理者，使页面更流畅
 * 解决方案：npm i default-passive-events -S
*/
import 'default-passive-events'

// import 'yunji-components/lib/styles/index.less'
import 'yunji-components/lib/yunji-components.css'

Vue.use(ElementUI, { size: 'small' })
Vue.use(yunjiComponents)

Vue.use((Vue) => {
  ((requireContext) => {
    const arr = requireContext.keys().map(requireContext);
    (arr || []).forEach((directive) => {
      directive = directive.__esModule && directive.default ? directive.default : directive
      Object.keys(directive).forEach((key) => {
        Vue.directive(key, directive[key])
      })
    })
  })(require.context('./directive', false, /^\.\/.*\.js$/))
})
Vue.prototype.$xss = DOMPurify.sanitize
Vue.use(ElementUI, {
  size: 'small'
})
Vue.use(GlobalUI)
Vue.use(bus)
Vue.prototype.$bus = bus

// register global utility filters.
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

// 开发环境警告
Vue.config.warnHandler = (msg, vm, trace) => {
  // `trace` 是组件的继承关系追踪
  console.warn(msg, vm, trace)
}
// 生产环境错误信息
// Vue.config.errorHandler = (err, vm) => {
//   // handle error
//   // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
//   // 只在 2.2.0+ 可用
//   console.error(err, vm)
// }

// 全局配置
Vue.config.productionTip = false
// Vue.config.errorHandler = function (err, vm, info) {
//   // 用作全局页面处理
//   // 异步则跳到 500 错误页面，并将错误信息传递过去
// }
// 设置title
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'IM客服系统'
  window.scrollTo(0, 0)
  next()
})

/**
 * 守望系统上传报错
 */
const returnPackage = () => {
  if (typeof window.JENKINS !== 'undefined' && window.JENKINS.packageName) {
    return {
      packageName: window.JENKINS.packageName,
      packageVersion: window.JENKINS.packageVersion
    }
  }
  return {}
}
/** 
 * 调用
 */
const yjerror = new YjErrorReport(Vue, {
  projectName: 'xinyunweb',
  environment: document.domain !== 'xinyunadmin.yunjiglobal.com' ? 'test' : 'release',
  packageName: returnPackage().packageName,
  packageVersion: returnPackage().packageVersion
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
